import React from 'react';
import { useSpaceConfigurationsConfig } from "../data/spaceconfigurationsconfig-hooks";
import DropDownEditor from '../../../shared/editors/DropDownEditor';
import DecimalEditor from "../../../shared/editors/DecimalEditor";
import Int32Editor from "../../../shared/editors/Int32Editor";
import StringEditor from "../../../shared/editors/StringEditor";

function SpaceConfiguration(props) {
    const { spaceConfigurationsConfig, updateSpaceConfiguration, getSpaceConfiguration, deleteSpaceConfiguration, restoreSpaceConfiguration, availableTypes } = useSpaceConfigurationsConfig();

    const leadSpaceConfigurationID = props.Id;
    const rep = getSpaceConfiguration(leadSpaceConfigurationID);
    const isActive = rep.IsActive;
    const deleteLabel = isActive ? "[![Delete]!]" : "[![Restore]!]";
    const deleteButtonClass = isActive ? "button k-button button-secondary" : "button k-button k-button-transparent";

    const updateState = (e) => {
        // Update the global state
        updateSpaceConfiguration(leadSpaceConfigurationID, e.props.id, e.value)
    }
    
    const OnDeleteClick = (ev) => {
        ev.preventDefault();
        if (isActive) {
            deleteSpaceConfiguration(leadSpaceConfigurationID);
        } else {
            restoreSpaceConfiguration(leadSpaceConfigurationID);
        }
    };
    
    const types = availableTypes(leadSpaceConfigurationID)

    return (
        <tr className="datagriditem">
            <DropDownEditor sortedOptions={types} value={rep.Type} onChange={updateState} id="Type"></DropDownEditor>
            <StringEditor value={rep.Description} onChange={updateState} id="Description"></StringEditor>
            <Int32Editor value={rep.Occupancy} onChange={updateState} id="Occupancy" min={0}></Int32Editor>
            <DecimalEditor value={rep.Area} onChange={updateState} id="Area" min={0}></DecimalEditor>
            <td className="align-center"><i className={rep.IsActive ? "fa fa-check" : ""}></i></td>
            <td>
                <button className={deleteButtonClass} type="button" onClick={OnDeleteClick}>
                    <span>{deleteLabel}</span>
                </button>
            </td>
        </tr>
    );
}

export default SpaceConfiguration;